import { createSignal, Show } from "solid-js"
import { useSearchParams } from "@solidjs/router"
import { createSkillMarketController } from "../skill-market/skill-market-controller"
import { useSkillMarketDirectory } from "../skill-market/skill-market-directory"
import { SkillMarketView } from "../skill-market/skill-market-view"
import { createScheduledTasksController } from "./scheduled-tasks-controller"
import { ScheduledTasksView, ScheduledTasksHistoryView } from "./scheduled-tasks-view"
import { createExpertController, ExpertView } from "../expert"
import { useServer } from "@/context/server"
import "../skill-market/skill-market.css"
import "../expert/expert.css"
import "./scheduled-tasks.css"

type SheetTab = "skills" | "automation" | "experts"

type AutomationTab = "tasks" | "history"

export function ScheduledTasksPage() {
  const server = useServer()
  const getSkillMarketDirectory = useSkillMarketDirectory()
  const skillController = createSkillMarketController(() => server.current?.http, getSkillMarketDirectory)
  const taskController = createScheduledTasksController()
  const expertController = createExpertController(() => server.current)
  const [params] = useSearchParams()
  const [sheet, setSheet] = createSignal<SheetTab>(
    params.tab === "skills" || params.tab === "automation" || params.tab === "experts"
      ? (params.tab as SheetTab)
      : "skills",
  )
  const [autoTab, setAutoTab] = createSignal<AutomationTab>(params.auto === "history" ? "history" : "tasks")

  return (
    <div class="scheduled-tasks-root">
      <div class="scheduled-tasks-sheet-tabs">
        <button
          class="scheduled-tasks-sheet-tab"
          classList={{ "scheduled-tasks-sheet-tab--active": sheet() === "skills" }}
          onClick={() => setSheet("skills")}
        >
          技能
        </button>
        <button
          class="scheduled-tasks-sheet-tab"
          classList={{ "scheduled-tasks-sheet-tab--active": sheet() === "automation" }}
          onClick={() => setSheet("automation")}
        >
          自动化
        </button>
        <button
          class="scheduled-tasks-sheet-tab"
          classList={{ "scheduled-tasks-sheet-tab--active": sheet() === "experts" }}
          onClick={() => setSheet("experts")}
        >
          专家库
        </button>
      </div>

      <Show when={sheet() === "skills"}>
        <SkillMarketView controller={skillController} />
      </Show>

      <Show when={sheet() === "experts"}>
        <ExpertView controller={expertController} />
      </Show>

      <Show when={sheet() === "automation"}>
        <div class="scheduled-tasks-sub-tabs">
          <button
            class="scheduled-tasks-sheet-tab"
            classList={{ "scheduled-tasks-sheet-tab--active": autoTab() === "tasks" }}
            onClick={() => setAutoTab("tasks")}
          >
            定时任务
          </button>
          <button
            class="scheduled-tasks-sheet-tab"
            classList={{ "scheduled-tasks-sheet-tab--active": autoTab() === "history" }}
            onClick={() => setAutoTab("history")}
          >
            运行记录
          </button>
        </div>
        <Show when={autoTab() === "tasks"}>
          <ScheduledTasksView controller={taskController} />
        </Show>
        <Show when={autoTab() === "history"}>
          <ScheduledTasksHistoryView controller={taskController} />
        </Show>
      </Show>
    </div>
  )
}

export default ScheduledTasksPage
